import React from "react";

const FilePanelDescription = ({ description, className }) => {
  const classDescription = className ? className : ""
  return (
    <div className={`${classDescription} upload-file__description`}>
      <p>{description}</p>
    </div>
  );
};

export default FilePanelDescription;
